<!-- <div *ngIf="errorMessage !== null" class="control-error">{{errorMessage}}</div> -->
<mat-error *ngIf="control.hasError('required')">
  <small [translate]="'FORM.VALIDATION.REQUIRED_FIELD'"> This is required. </small>
</mat-error>
<mat-error *ngIf="control.hasError('email')">
  <small [translate]="'FORM.VALIDATION.INVALID_FIELD'">
    Please provide a valid email.
  </small>
</mat-error>
<mat-error *ngIf="control.hasError('minlength')">
  <small>
    {{ 'FORM.VALIDATION.MIN_LENGTH_FIELD' | translate }}
    {{ control.errors.minlength.requiredLength }}
    <!-- Value should be at least {{minlength}} characters. -->
  </small>
</mat-error>
<mat-error *ngIf="control.hasError('maxlength')">
  <small>
    {{ 'FORM.VALIDATION.MAX_LENGTH_FIELD' | translate }}
    {{ control.errors.maxlength.requiredLength }}
  </small>
</mat-error>
<mat-error *ngIf="control.hasError('whitespace')">
  <small> Please enter valid data </small>
</mat-error>
<mat-error
  *ngIf="
    errorType &&
    errorType === 'password' &&
    !control.hasError('maxlength') &&
    control.value &&
    control.value.length === passMaxLength
  "
>
  <small> {{ 'FORM.VALIDATION.MAX_CHARACTER_LIMIT' | translate }} </small>
</mat-error>

<!-- <small class="danger" *ngIf="control.hasError('required') && (submitted || control.touched)">This is required</small>
<small class="danger" *ngIf="control.hasError('email') && (submitted || control.touched)">Please provide valid email</small> -->
<!-- <small class="danger" *ngIf="control.hasError('required')">This is required</small>
<small class="danger" *ngIf="control.hasError('email')">Please provide valid email</small> -->
